require('./bootstrap');
require('select2');
// require('./cards-until-nav-change');
require('./results');
require('./momentresults');
require('./adminreport');
import Alpine from 'alpinejs'
require ('./map');

window.Alpine = Alpine

